import AreaSelector from './src/main';

/* istanbul ignore next */
AreaSelector.install = function(Vue) {
  Vue.component(AreaSelector.name, AreaSelector);
};

export default AreaSelector;
